/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 乗車料金を修正するリクエスト
 * @export
 * @interface UpdateBillingFareRequest
 */
export interface UpdateBillingFareRequest {
    /**
     * 注文種別（運賃）
     * @type {number}
     * @memberof UpdateBillingFareRequest
     */
    fareType: UpdateBillingFareRequestFareTypeEnum;
    /**
     * 注文種別（配車）
     * @type {number}
     * @memberof UpdateBillingFareRequest
     */
    orderType: UpdateBillingFareRequestOrderTypeEnum;
    /**
     * 実行状況
     * @type {number}
     * @memberof UpdateBillingFareRequest
     */
    executionStatus: UpdateBillingFareRequestExecutionStatusEnum;
    /**
     * 配車状態
     * @type {number}
     * @memberof UpdateBillingFareRequest
     */
    carStatus?: UpdateBillingFareRequestCarStatusEnum;
    /**
     * 実績支払方法
     * @type {string}
     * @memberof UpdateBillingFareRequest
     */
    paymentMethod?: UpdateBillingFareRequestPaymentMethodEnum | null;
    /**
     * 乗車料金
     * @type {number}
     * @memberof UpdateBillingFareRequest
     */
    rideFee: number;
    /**
     * 有料道路料金および立替金
     * @type {number}
     * @memberof UpdateBillingFareRequest
     */
    tollRoadFee: number;
    /**
     * 変更理由等を記録するメモ（最大100文字）
     * @type {string}
     * @memberof UpdateBillingFareRequest
     */
    note?: string;
}


/**
 * @export
 */
export const UpdateBillingFareRequestFareTypeEnum = {
    METER: 0,
    PRE_FIXED: 1,
    FLAT: 2
} as const;
export type UpdateBillingFareRequestFareTypeEnum = typeof UpdateBillingFareRequestFareTypeEnum[keyof typeof UpdateBillingFareRequestFareTypeEnum];

/**
 * @export
 */
export const UpdateBillingFareRequestOrderTypeEnum = {
    NORMAL: 0,
    RESERVATION: 1
} as const;
export type UpdateBillingFareRequestOrderTypeEnum = typeof UpdateBillingFareRequestOrderTypeEnum[keyof typeof UpdateBillingFareRequestOrderTypeEnum];

/**
 * @export
 */
export const UpdateBillingFareRequestExecutionStatusEnum = {
    NOT_EXECUTED: 0,
    EXECUTED: 1
} as const;
export type UpdateBillingFareRequestExecutionStatusEnum = typeof UpdateBillingFareRequestExecutionStatusEnum[keyof typeof UpdateBillingFareRequestExecutionStatusEnum];

/**
 * @export
 */
export const UpdateBillingFareRequestCarStatusEnum = {
    REQUESTED: 1,
    SEARCH_FAILED: 2,
    DISPATCHED: 3,
    ARRIVED: 4,
    ON_BOARD: 5,
    SUBSTITUTE_REQUESTED: 6,
    PAYMENT_COMPLETED: 7,
    ONLINE_PAYMENT_FAILED: 8,
    ON_BOARD_QR: 9,
    UNUSED: 10,
    USER_CANCELED: 11,
    OPERATOR_CANCELED: 12,
    QR_CANCELED: 13
} as const;
export type UpdateBillingFareRequestCarStatusEnum = typeof UpdateBillingFareRequestCarStatusEnum[keyof typeof UpdateBillingFareRequestCarStatusEnum];

/**
 * @export
 */
export const UpdateBillingFareRequestPaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type UpdateBillingFareRequestPaymentMethodEnum = typeof UpdateBillingFareRequestPaymentMethodEnum[keyof typeof UpdateBillingFareRequestPaymentMethodEnum];


/**
 * Check if a given object implements the UpdateBillingFareRequest interface.
 */
export function instanceOfUpdateBillingFareRequest(value: object): value is UpdateBillingFareRequest {
    if (!('fareType' in value) || value['fareType'] === undefined) return false;
    if (!('orderType' in value) || value['orderType'] === undefined) return false;
    if (!('executionStatus' in value) || value['executionStatus'] === undefined) return false;
    if (!('rideFee' in value) || value['rideFee'] === undefined) return false;
    if (!('tollRoadFee' in value) || value['tollRoadFee'] === undefined) return false;
    return true;
}

export function UpdateBillingFareRequestFromJSON(json: any): UpdateBillingFareRequest {
    return UpdateBillingFareRequestFromJSONTyped(json, false);
}

export function UpdateBillingFareRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingFareRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fareType': json['fareType'],
        'orderType': json['orderType'],
        'executionStatus': json['executionStatus'],
        'carStatus': json['carStatus'] == null ? undefined : json['carStatus'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : json['paymentMethod'],
        'rideFee': json['rideFee'],
        'tollRoadFee': json['tollRoadFee'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function UpdateBillingFareRequestToJSON(json: any): UpdateBillingFareRequest {
    return UpdateBillingFareRequestToJSONTyped(json, false);
}

export function UpdateBillingFareRequestToJSONTyped(value?: UpdateBillingFareRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fareType': value['fareType'],
        'orderType': value['orderType'],
        'executionStatus': value['executionStatus'],
        'carStatus': value['carStatus'],
        'paymentMethod': value['paymentMethod'],
        'rideFee': value['rideFee'],
        'tollRoadFee': value['tollRoadFee'],
        'note': value['note'],
    };
}

